<template>
  <div class="swiper">
    <ul class="list" :style="{height:height+'px'}">
      <slot></slot>
    </ul>
    <i v-show="showTag" class="el-icon-arrow-left icon left" @click="handleSwitch('left')"></i>
    <i v-show="showTag" class="el-icon-arrow-right icon right" @click="handleSwitch('right')"></i>
  </div>
</template>
<script>
export default {
  name: 'BaseSwiper',
  props: {
    height: {
      type: Number,
      default: 120
    },
    // 如果我们希望两个轮播之间存在间隔 设置此参数而不用使用margin
    gap: {
      type: Number,
      default: 10
    },
    delay: {
      type: Number,
      default: 200
    },
    // 是否开启限速 用于处理点击速度过快的问题 目前使用delay 0进行处理，如果希望进行限速 也可以使用限速模式进行处理 即最快delay时间切换一张
    speedLimit: {
      type: Boolean,
      default: false //默认不开启
    }
  },
  components: {},
  data() {
    return {
      showFlag: true,
      offsetWidth: 0, //偏移距离
      offsetArr: [],
      criticalIndex: -1, //临界元素 次元素在移动的时候优先级最低
      showTag: true,
      canSwitch: true //是否可以进行切换
    };
  },
  computed: {
    // 获取子元素
    items() {
      return this.$children.length > 0
        ? this.$children.filter(v => v.$options.name === 'BaseSwiperItem')
        : [];
    },
    // 子元素个数
    itemNumber() {
      return this.items.length;
    }
  },
  mounted() {
    this.offsetWidth = (this.$el.offsetWidth + this.gap) / 3.4;
    // console.log(this.offsetWidth);
    // 获取最开始的时候的排列
    for (let i = 0; i < this.itemNumber; i++) {
      if (i === this.itemNumber - 1 && this.itemNumber > 3) {
        this.offsetArr.push(-this.offsetWidth);
      } else {
        this.offsetArr.push(i * this.offsetWidth);
      }
    }
    if (this.itemNumber <= 3) {
      this.showTag = false;
    }
    this.updateItem();
  },
  methods: {
    updateItem() {
      // 逐个设置item的offsetWidth
      this.offsetArr.forEach((v, index) => {
        // 是否是临界元素
        let isCritical = this.criticalIndex === index;
        this.items[index].setOffset(v, isCritical);
      });
    },
    handleSwitch(type) {
      this.showFlag = false;
      // 如果不可以切换
      if (!this.canSwitch) return;
      if (this.speedLimit) {
        this.canSwitch = false;
        setTimeout(() => {
          this.canSwitch = true;
        }, this.delay);
      }
      // 切换
      // 先全部向一边走
      // let oldOffsetArr = this.offsetArr
      if (this.itemNumber > 4) {
        this.switchExceed5(type);
      } else {
        this.switchUnder5(type);
      }
      // 切换后进行更新
      this.updateItem();
    },
    // 大于等于5张的时候的操作方式
    switchExceed5(type) {
      if (type === 'left') {
        this.switchExceed5LeftMove();
      } else {
        this.switchExceed5RightMove();
      }
    },
    // 大于等于五张的时候向左移动
    switchExceed5LeftMove() {
      this.offsetArr = this.offsetArr.map((v, index) => {
        // 根据偏移量进行判断 如果已经是负数了 则往回走
        if (v >= (this.itemNumber - 2) * this.offsetWidth) {
          this.criticalIndex = index;
          return -this.offsetWidth;
        }
        return v + this.offsetWidth;
      });
    },
    // 大于等于五张的时候向右移动
    switchExceed5RightMove() {
      this.offsetArr = this.offsetArr.map((v, index) => {
        // 根据偏移量进行判断 如果已经是负数了 则往回走
        if (v < 0) {
          this.criticalIndex = index;
          return this.offsetWidth * (this.itemNumber - 2);
        }
        return v - this.offsetWidth;
      });
    },
    // 小于五张的时候的操作
    switchUnder5(type) {
      if (type === 'left') {
        this.switchUnder5LeftMove();
      } else {
        this.switchUnder5RightMove();
      }
    },
    switchUnder5LeftMove() {
      this.criticalIndex = this.offsetArr.findIndex(
        v => v === this.offsetWidth * (this.itemNumber - 2)
      );
      let item = this.offsetArr.shift();
      // console.log(item);
      this.offsetArr.push(item);
    },
    switchUnder5RightMove() {
      // this.criticalIndex = this.offsetArr.findIndex(
      //   v => v === this.offsetWidth * (this.itemNumber - 2)
      // );
      // console.log(this.criticalIndex);
      // let item = this.offsetArr.shift();
      // this.offsetArr.push(item);
      // 此时临界元素偏移量必定最大
      this.criticalIndex = this.offsetArr.findIndex(
        v => v === -this.offsetWidth
      );
      let item = this.offsetArr.pop();
      // console.log(item);
      this.offsetArr.unshift(item);
    }
  }
};
</script>
<style scoped>
.swiper {
  position: relative;
}
.list {
  z-index: 6;
  overflow: hidden;
  position: relative;
  /* padding: 0 80px; */
  /* background: red; */
  width: 1300px;
  margin: auto;
}
.icon {
  position: absolute;
  border-radius: 6px;
  z-index: 99;
  top: 50%;
}
.left {
  width: 50px;
  left: 25px;
  height: 50px;
  border-radius: 50%;
  line-height: 47px;
  cursor: pointer;
  border: 1px solid rgb(0, 189, 183);
  color: rgb(0, 189, 183);
  text-align: center;
}
.left:hover {
  background: rgb(0, 189, 183);
  color: #ffffff;
}
.right:hover {
  background: rgb(0, 189, 183);
  color: #ffffff;
}
.right {
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  line-height: 47px;
  cursor: pointer;
  border: 1px solid rgb(0, 189, 183);
  color: rgb(0, 189, 183);
  text-align: center;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .list {
    width: 1190px !important;
  }
  .left {
    left: -22px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base-swiper.vue